<div class="loader-box">
    <div class="loader">
        <img src="assets/img/logo-fill.svg" width="165" height="134" alt="Loader Main">
    </div>
</div>